import { useState, useEffect } from "react";
import moment from "moment";
import reportService from "../services/reportService";

export const useWinLoseReport = () => {
  const [rows, setRows] = useState([]);
  const [showData, setShowData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

  const fetchReportData = async (filters = {}) => {
    setLoading(true);
    try {
      const payload = { startDate, endDate, ...filters };
      const response = await reportService.winloseReport(payload);
      if (response.status === 200) {
        const sortedByName = [...response.data].sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        setRows(sortedByName);
        setShowData(sortedByName);
        return sortedByName;
      }
    } catch (err) {
      console.error("Failed to fetch report:", err);
    } finally {
      setLoading(false);
    }
    return [];
  };

  useEffect(() => {
    fetchReportData();
  }, []);

  return { rows, showData, loading, startDate, endDate, setShowData,setStartDate, setEndDate, fetchReportData };
};
